import { SingleServiceCenter } from "api"
import { useIsDesktop } from "common/MediaQueries"
import { memo } from "react"
import styled from "styled-components"
import { useMapContext } from "../map/MapContext"
import ServiceCentersItem from "./ServiceCentersItem"

const StyledList = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;
  direction: rtl;
  text-align: right;
  height: 100%;
  ${(p) => p.theme.breakpoints.up("md")} {
    padding-right: 10px;
  }
`
const StyledListItem = styled.li``

const ServiceCentersList = () => {
  const isDesktop = useIsDesktop()
  const { selectedStore, onStoreClick, filterStores } =
    useMapContext<SingleServiceCenter>()

  return (
    <StyledList>
      {!!filterStores?.length && (
        <>
          {filterStores.map((item, i) =>
            isDesktop ? (
              <StyledListItem
                key={i}
                tabIndex={0}
                onClick={() => {
                  onStoreClick(item)
                }}
              >
                <ServiceCentersItem
                  serviceCenter={item}
                  isServiceCenterSelected={selectedStore?.id === item?.id}
                />
              </StyledListItem>
            ) : (
              <StyledListItem key={i}>
                <ServiceCentersItem
                  serviceCenter={item}
                  isServiceCenterSelected={selectedStore?.id === item?.id}
                />
              </StyledListItem>
            )
          )}
        </>
      )}
    </StyledList>
  )
}

export default memo(ServiceCentersList)
